import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Control, Controller, FieldValues } from 'react-hook-form';
import React from 'react';

export interface ToggleField {
  id: string;
  label?: string;
  name?: string;
  required?: boolean;
  control: Control<FieldValues, any>;
  buttons: { label: string; value: unknown }[];
}

export const ToggleField = ({
  id,
  name,
  required = false,
  buttons,
  control,
  label,
}: ToggleField) => {
  return (
    <Controller
      rules={{ required }}
      control={control}
      name={name ?? id}
      render={({ field }) => {
        return (
          <ToggleButtonGroup
            {...field}
            aria-labelledby="group"
            value={field.value}
            exclusive
            sx={{
              paddingLeft: 0,
              marginLeft: 0,
              marginTop: '5px',
            }}
          >
            <Stack>
              <p
                style={{
                  fontSize: '16px',
                  color: 'rgba(0, 0, 0, 0.6)',
                  padding: '5px 0',
                  margin: 0,
                }}
              >
                {label}
              </p>
              <Stack direction="row">
                {buttons?.map(
                  (
                    {
                      label: buttonLabel,
                      value,
                    }: { label: string | React.ReactElement; value: unknown },
                    index: number
                  ) => {
                    return (
                      <ToggleButton
                        key={index}
                        value={String(value)}
                        sx={styles(
                          index,
                          String(field.value),
                          String(value),
                          buttons.length
                        )}
                        onChange={(
                          event: React.MouseEvent<HTMLElement>,
                          buttonValue: string
                        ) => {
                          if (String(buttonValue) === String(field.value)) {
                            return field.onChange(null);
                          }

                          return field.onChange(buttonValue);
                        }}
                      >
                        {buttonLabel}
                      </ToggleButton>
                    );
                  }
                )}
              </Stack>
            </Stack>
          </ToggleButtonGroup>
        );
      }}
    />
  );
};

const styles = (
  index: number,
  fieldValue: string,
  value: string,
  length: number
) => {
  return {
    background: fieldValue === value ? '#EBEBEB' : '',
    borderBottomRightRadius:
      index === 0 ? 0 : index !== 0 && index !== length - 1 ? 0 : 4,
    borderTopRightRadius:
      index === 0 ? 0 : index !== 0 && index !== length - 1 ? 0 : 4,
    borderBottomLeftRadius:
      index === length - 1 ? 0 : index !== length - 1 && index !== 0 ? 0 : 4,
    borderTopLeftRadius:
      index === length - 1 ? 0 : index !== length - 1 && index !== 0 ? 0 : 4,
  };
};
